import { Component } from '@angular/core';

import { AlertController, NavController } from 'ionic-angular';

import { LoginPage } from '../login/login';
import { UserData } from '../../providers/user-data';
import { CommonData } from '../../providers/common-data';

import { Platform } from 'ionic-angular';
import { AppVersion } from '@ionic-native/app-version';

@Component({
  selector: 'page-account',
  templateUrl: 'account.html'
})
export class AccountPage {
  email: string;
  appversionnumber:any;
  constructor(public alertCtrl: AlertController
            , public nav: NavController
            , public userData: UserData 
            , public platform:Platform
            , private appVersion: AppVersion     
            , public common: CommonData       
  ) {

  }

  ngAfterViewInit() {
    console.log(this.platform);
    this.email = this.userData.email;

    this.appVersion.getVersionCode().then(versionnumber => {
      this.appversionnumber = versionnumber;
    });     
  }

  updatePicture() {
    console.log('Clicked to update picture');
  }
  doToggle(event){
    this.userData.setStoreimageslocally(this.userData.storeimageslocally);
  }

  doToggleEditmode(event){
    this.userData.setEditmode(this.userData.editmode);
  }    

  doSaveKontrollwidget(event){
    console.log("doSaveKontrollwidget");
    console.log(this.userData.kontrollwidget);
    this.userData.setKontrollwidget(this.userData.kontrollwidget);
  }    

  doChangeImagequality(){
    this.userData.setImagequality(this.userData.imagequality);    
  }
  // Present an alert with the current username populated
  // clicking OK will update the username and display it
  // clicking Cancel will close the alert and do nothing


  logout() {
    this.userData.logout();
  }
}



// WEBPACK FOOTER //
// ./src/pages/account/account.ts